import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import MeetNick from "@/components/site/MeetNick";
import Services from "@/components/site/Services";
import CampaignMaterials from "@/components/site/CampaignMaterials";
import ModernTools from "@/components/site/ModernTools";
import Pricing from "@/components/site/Pricing";
import WeHaveYourBack from "@/components/site/WeHaveYourBack";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";

export default function Home() {
    return (
        <div data-testid="home-page" className="relative bg-ink text-cream overflow-x-hidden">
            <Navigation />
            <main>
                <Hero />
                <MeetNick />
                <Services />
                <CampaignMaterials />
                <ModernTools />
                <Pricing />
                <WeHaveYourBack />
                <ContactForm />
            </main>
            <Footer />
        </div>
    );
}
